var map = {
	"./symbol_0.png": 43619,
	"./symbol_1.png": 53786,
	"./symbol_10.png": 9216,
	"./symbol_11.png": 33417,
	"./symbol_12.png": 85234,
	"./symbol_2.png": 13681,
	"./symbol_3.png": 81640,
	"./symbol_4.png": 83636,
	"./symbol_5.png": 85470,
	"./symbol_6.png": 5845,
	"./symbol_7.png": 94220,
	"./symbol_8.png": 98235,
	"./symbol_9.png": 76690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 838;